<template>
  <div class="flex flex-1">
    <base-flex-spinner v-if="loading" />
    <div
      v-else
      class="flex flex-1 flex-col"
    >
      <div v-if="!selectProduct" class="-mt-2 mb-2">
        <span class="text-primary cursor-pointer font-bold" @click="selectProduct=true">
          Retour à la sélection
        </span>
        <p class="text-sm">
          À gauche, retrouvez les produits sélectionnés (les produits grisés sont exclus).
        </p>
        <p class="text-sm">
          À droite, examinez les interactions médicamenteuses détectées par Vidal. Les alertes sont classées : marron
          pour les contre-indications, rouge pour les associations déconseillées, orange pour les précautions d’emploi,
          et jaune pour celles à surveiller.
        </p>
      </div>
      <drug-selection
        v-if="selectProduct"
        :consumer-key="consumerKey"
        @launch-analysis="getInteractionWebsite"
        @track-products="$emit('track-products')"
      />
      <drug-interaction
        v-else-if="webpage"
        :link="webpage"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import {ref} from "vue";
import {drugInteractionApi} from '@/container';
import DrugInteraction from '@/drug-interaction/components/DrugInteraction.vue';
import DrugSelection from '@/drug-interaction/components/DrugSelection.vue';
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";

defineEmits<{
    (e: 'track-products'): void;
}>();

const {consumerKey, customerId} = defineProps<{ consumerKey: string; customerId: number; }>();

const selectProduct = ref(true);
const loading = ref(false);
const webpage = ref<string | null>(null);

/**
 * Retrieve the interaction website for the given CIPs.
 *
 * @param cips
 */
const getInteractionWebsite = (cips: string[]) => {
    selectProduct.value = false;
    loading.value = true;
    drugInteractionApi()
        .read(cips, customerId)
        .then(response => {
            webpage.value = response.prisca_path;
        })
        .finally(() => {
            loading.value = false;
        });
};

</script>
